export const config = {
  thresholds: {
    display: {
      // Display by SKU if <= 5 Product IDs
      bySKU: 5,
      byID: 6
    }
  },
  classes: {
    selected: 'attr selected js-rendered',
    default: 'attr js-rendered',
    hidden: 'attr hide js-rendered',
    appliedFilter: 'applied-filter'
  }
}
